import { AlertTriangle, FlaskConical } from "lucide-react";

export default function ModeBanner({ mode, testnet, v2 }) {
  if (v2) {
    return (
      <div data-testid="mode-indicator-badge" className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-[#F59E0B]/60 bg-[#F59E0B]/15 text-[#F59E0B] text-xs sm:text-sm font-bold">
        <FlaskConical className="h-4 w-4" /> TEST — SANAL BAKİYE (Demo/Testnet) · Canlı mod kapalı
      </div>
    );
  }
  if (mode === "live") {
    return (
      <div
        data-testid="mode-indicator-badge"
        className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-[#DC2626] bg-[#DC2626]/15 text-[#F87171] text-xs sm:text-sm font-bold live-pulse"
      >
        <AlertTriangle className="h-4 w-4" />
        CANLI İŞLEM MODU AKTİF — Gerçek Binance Futures {testnet ? "(Testnet)" : "(Mainnet)"}
      </div>
    );
  }
  return (
    <div
      data-testid="mode-indicator-badge"
      className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-[#F59E0B]/50 bg-[#F59E0B]/15 text-[#F59E0B] text-xs sm:text-sm font-bold"
    >
      <FlaskConical className="h-4 w-4" />
      DENEME MODU (PAPER) — Gerçek Sermaye Riskte Değil
    </div>
  );
}
